import React from "react";
import { RaisedButton } from "material-ui";
import BaseOverlay from "../overlays/base.jsx";

class ReselectSeatsWarning extends React.Component {
  constructor(props) {
    super(props);

    this.stay = this.stay.bind(this);
    this.reselect = this.reselect.bind(this);
  }

  reselect() {
    this.props.reselect();
  }

  stay() {
    this.props.stay();
  }

  render() {
    return (
      <div style={{ textAlign: "center", fontSize: "11pt", padding: 15, paddingBottom: 35 }}>
        <h3>
          Are you sure you want to leave checkout?
        </h3>        
        <div>
          <p>
            If you leave this page, you'll lose your hold on the currently selected seats.
          </p>
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Reselect seats"          
              onClick={this.reselect}
            />
            <RaisedButton
              label="Stay in checkout"
              primary={true}
              style={{ marginLeft: 15 }}
              onClick={this.stay}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ReselectSeatsWarning;



// WEBPACK FOOTER //
// ./src/app/components/partials/reselect-seats-warning.jsx